import React, {useEffect, useMemo, useState} from 'react';
import {Col, Row} from 'reactstrap';
import {AvForm, AvRadio, AvRadioGroup} from 'availity-reactstrap-validation';
import {StepComponentProps} from '../followup-modal';
import {EmergencyType} from 'app/shared/model/enumerations/emergency-type.model';
import {IPatientBaby} from 'app/shared/model/patient-baby.model';
import FollowupButtons from '../followup-buttons';
import '../followup.scss';
import motherEmergencyType from "app/entities/registration/registration-steps/mother-emergency-type";

interface BabyFollowupOutcomesStepProps extends StepComponentProps {
  updateCurrentBaby?: (updates: Partial<IPatientBaby>) => void;
  currentBabyIndex?: number;
}

const BabyFollowupOutcomesStep: React.FC<BabyFollowupOutcomesStepProps> = ({
                                                                             formData,
                                                                             updateFormData,
                                                                             onNext,
                                                                             onPrevious,
                                                                             canGoBack,
                                                                             canGoNext,
                                                                             patientCaseType,
                                                                             journey,
                                                                             babyFollowupData,
                                                                             updateCurrentBaby,
                                                                             currentBabyIndex = 0,
                                                                           }) => {
  const currentBaby = formData.patientBabies?.[currentBabyIndex];
  const [selectedFollowup, setSelectedFollowup] = useState<string | null>(currentBaby?.outcomeId || null);

  const patientCountryId = journey.patientCase?.patient?.countryId;

  // Filter followups for baby outcomes based on alive status
  const babyFollowupOutcomes = useMemo(() => {
    return babyFollowupData?.filter(followup => {
      return (
        followup.isAlive === currentBaby?.isAlive
      );
    }) || [];
  }, [babyFollowupData, currentBaby?.isAlive]);

  const displayFollowups = babyFollowupOutcomes;

  useEffect(() => {
    if (updateCurrentBaby) {
      updateCurrentBaby({outcomeId: selectedFollowup});
    }
  }, [selectedFollowup]);

  const handleFollowupChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedFollowup(e.target.value);
  };

  const handleSubmit = (event: any, values: any) => {
    onNext();
  };

  return (
    <div className="followup-step-container">
      <div className="followup-step-content">
        <h6 className="text-primary mb-4">
          Select Baby{currentBabyIndex > 0 ? `#${currentBabyIndex + 1}` : ''} <span className="text-danger">follow-up outcome</span>
        </h6>
        <AvForm onValidSubmit={handleSubmit}>
          <AvRadioGroup
            name="babyFollowupOutcome"
            required={displayFollowups.length > 0}
            value={selectedFollowup}
            className="form-control"
            style={{overflowY: 'auto', height: '400px'}}
          >
            <Row>
              {displayFollowups.length === 0 ? (
                <Col md="12">
                  <div className="text-center py-4">
                    <div className="text-muted">No follow-up outcomes available for this patient status.</div>
                  </div>
                </Col>
              ) : (
                displayFollowups.map((followup) => (
                  <Col md="12" key={followup.id}>
                    <AvRadio
                      name="babyFollowupOutcome"
                      value={followup.id}
                      onChange={handleFollowupChange}
                      label={followup.enFollowup}
                    />
                  </Col>
                ))
              )}
            </Row>
          </AvRadioGroup>

          <FollowupButtons
            currentStep={9}
            totalSteps={13}
            canGoBack={canGoBack}
            onPrevious={onPrevious}
          />
        </AvForm>
      </div>
    </div>
  );
};

export default BabyFollowupOutcomesStep;
